<template>
  <div
    class="modal fade"
    id="certiAccInfoWModal"
    tabindex="-1"
    aria-labelledby="certiAccInfoWModalWModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              서티라이프 멤버 등록하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalInputDiv">
              <label for="">이름</label>
              <input
                type="text"
                placeholder="이름을 입력해주세요."
                v-model="managerName"
              />
            </div>
            <div class="modalInputDiv">
              <label for="">아이디</label>
              <input
                type="text"
                placeholder="서티라이프 임직원 이메일을 등록해주세요."
                v-model="managerId"
              />
            </div>
            <div class="modalInputDiv">
              <label for="">휴대폰 번호</label>
              <input
                type="text"
                placeholder="휴대폰 번호를 입력해 주세요."
                v-model="managerPhoneNumber"
                maxlength="13"
                @input="changeManagerPhoneNumber"
              />
            </div>
            <div style="height: 30px;"/>
            <div class="modalInputDiv">
              <label for="">비밀번호</label>
              <input
                type="password"
                placeholder="비밀번호를 입력해주세요."
                v-model="password"
                @input="passwordOnChange"
              />
            </div>
            <div class="modalInputDiv">
              <label for="">비밀번호 확인</label>
              <input
                type="password"
                placeholder="비밀번호를 다시 입력해주세요."
                v-model="passwordConfirm"
                @input="passwordOnChange"
              />
            </div>
            <!-- 운영자 계정 생성 사유·인사 근거(계약 PERMISSIONS 6 · CI-13, W6 A6) — 선택, 적으면 보냄 -->
            <div class="modalInputDiv">
              <label for="">사유(선택)</label>
              <select v-model="reasonCode">
                <option value="">사유를 고르세요</option>
                <option v-for="r in STAFF_REASONS" :key="r.value" :value="r.value">{{ r.label }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label for="">인사 근거(선택)</label>
              <input type="text" placeholder="결재·발령 번호 등" v-model="hrRef" maxlength="100" />
            </div>
         
           
            
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="addCertilifeAccount()"
          >
            등록하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openDialog, phoneNumberFormatter } from "../../utils/utils";
import { STAFF_REASONS, staffReasonFields } from "../../utils/accountRows";

export default {
  data() {
    return {
      managerName: "", // 관리자 이름
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
      password: "", // 관리자 비밀번호
      passwordConfirm: "", // 비밀번호 확인

      isPasswordValid: false, // 비밀번호 유효성 검증 여부 
      STAFF_REASONS,
      reasonCode: "", // 생성 사유(HIRE 등, CI-13)
      hrRef: "", // 인사 근거
    };
  },

  async mounted() {
    this.initValues();
  },
  methods: {
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },
    // 주요 API

    // 계정 등록
    async addCertilifeAccount() {
      if(await this.validateData()) {
        try {
          const obj = {};
          obj.username = this.managerId;
          obj.mobile = this.managerPhoneNumber.replace(/-/g, '');
          obj.name = this.managerName;
          obj.password = this.password;
          Object.assign(obj, staffReasonFields(this.reasonCode, this.hrRef));

          const response = await this.$apiInstance.post(`/accounts/certilife`, obj);
          if(response.status === 200 || response.status === 201) {
            await openDialog("계정 등록이 완료되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
          } else {
            await openDialog("계정 등록에 실패하였습니다.", "error", "확인");
          }

        } catch (error) {
          console.log(error);
          if(error.response && error.response.status === 400) {
            await openDialog("이미 존재하는 계정입니다.", "error", "확인");
          }
        }
      }
    },


    // 비밀번호 onchange
    passwordOnChange() {
      if(this.password && (this.password !== this.passwordConfirm)) {
        this.isPasswordValid = false;
      } else {
        this.isPasswordValid = true;
      }
    },


    // 업로드 전 검증
    async validateData() {
      let result = true;

      if (!this.managerName) {
        await openDialog("이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerId) {
        await openDialog("아이디를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerPhoneNumber) {
        await openDialog("휴대폰 번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.password) {
        await openDialog("비밀번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.passwordConfirm) {
        await openDialog("입력한 비밀번호를 다시 입력해 주세요.", "error", "확인");
        result = false;
      } else if (!this.isPasswordValid) {
        await openDialog("비밀번호가 일치하지 않습니다.", "error", "확인");
        result = false;
      }
      return result;
    },

    
 

    // 기타 hospitalInfoW용 utils

    // 항목 초기화 용도
    initValues() {
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.password = "";
      this.passwordConfirm = "";
    },
  },
};
</script>
